<template>
  <div class="container">
    <h1>
    Pipelines
    </h1>
  </div>
</template>

<script>
  export default {
    name: "Pipelines",
  }
</script>

<style scoped>
.container {
  padding-top: 4rem;
  height: 100%;
}
</style>